'use client';

import { useAuth } from '@clerk/nextjs';
import { usePathname } from 'next/navigation';
import { Navbar } from './navbar';
import { AdminNavbar } from './admin-navbar';

export function ConditionalNavbar() {
  const pathname = usePathname();
  const { isSignedIn, isLoaded } = useAuth();
  const isAuthPage = pathname?.startsWith('/sign-in') || pathname?.startsWith('/sign-up') || pathname?.startsWith('/accept-invitation');
  // Match both old format /[agentId]/demo-chat and new format /[token]/chat
  const isDemoChatPage = pathname?.match(/^\/[^/]+\/(demo-chat|chat)/);
  // Hide navbar during onboarding flow
  const isOnboardingPage =
    pathname === '/onboarding' ||
    pathname === '/onboarding-v2' ||
    pathname === '/onboarding-v3' ||
    pathname === '/post-sign';
  const isCreateAgentPage = pathname?.startsWith('/create-agent');
  const isMarketingPage = pathname?.startsWith('/marketing');
  const isAdminPage = pathname === '/admin' || pathname?.startsWith('/admin/');
  const isMatrixFramePreview = pathname?.endsWith('/matrix/frame');

  if (isAuthPage || isDemoChatPage || isOnboardingPage || isCreateAgentPage || isMarketingPage || isMatrixFramePreview) {
    return null;
  }

  // FAQ is public; signed-out visitors get a navbar-less layout (see /faq page).
  if (pathname === '/faq') {
    if (!isLoaded) {
      return null;
    }
    if (!isSignedIn) {
      return null;
    }
  }

  if (isAdminPage) {
    return (
      <div className="print:hidden">
        <AdminNavbar />
      </div>
    );
  }

  return (
    <div className="print:hidden">
      <Navbar />
    </div>
  );
}

